import {Component, Input, OnInit, ViewChild, ViewContainerRef} from '@angular/core';

@Component({
  selector: 'app-ra-progress-body',
  templateUrl: './ra-progress-body.component.html',
  styleUrls: ['./ra-progress-body.component.css']
})
export class RaProgressBodyComponent implements OnInit {

  @Input() step = ''; // step1,step2,step3,step4
  @Input() mobile:boolean = false; // mobile要顯示進度label
  @ViewChild('templateRef', {static: true}) templateRef:any; // 這樣才能避免多包一層; ng8需要static:true

  constructor(
      private viewContainerRef: ViewContainerRef
  ) { }

  ngOnInit(): void {
    this.viewContainerRef.createEmbeddedView(this.templateRef);
  }

}
